import PubSub from "underpub-js";

var CalloutList = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-CalloutList',
	};

	$.extend(true, this.options, options);

};

CalloutList.prototype.init = function() {

	var self = this;

};

export default CalloutList;
